import React, { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { type FavoriteMenuItemProps } from '../../Models/MenuItemProps';
import Styles from '../Menu/Menu.module.scss';
import { CustomMenuIcons, MenuIcons } from '../Menu/MenuIcons';
import ROW2Mapping from '../Menu/ROW2Mapping';
import { DobButton } from '@dedalusdiit/dob-components';
import { useSortable } from '@dnd-kit/react/sortable';
import { handleMenuItemClick } from '@/Routes/Helper/MenuItemHandler';

function MenuFavoriteItemLink(props: Readonly<FavoriteMenuItemProps>): React.ReactElement {
    const theme = useTheme();
    const navigate = useNavigate();
    const { icon, primary, to, sub, full, onRemove, index } = props;
    const Comp = MenuIcons[icon as keyof React.ElementType] ?? (theme.palette.mode === 'dark' ? CustomMenuIcons[icon as keyof React.ElementType] : CustomMenuIcons[icon + 'Black' as keyof React.ElementType]);
    const fullTo = useMemo(() => {
        if (full.Parameters === null || full.Parameters === '') {
            return to;
        }
        return `${to}?${full.Parameters}`;
    }, [full, to]);

    const openExternal = (e: React.MouseEvent): void => {
        e.stopPropagation();
        e.preventDefault();
        window.open(window.location.origin + ROW2Mapping[to], '_blank');
    };

    const { ref } = useSortable({ id: to, index });

    return (
        <Link to={fullTo} className={sub ? Styles.subNav : Styles.navItem} ref={ref} onClick={(e) => {
            void handleMenuItemClick(navigate, fullTo, e); 
        }}>
            <div className={Styles.navIconAndText}>
                { Comp && <div className={Styles.navIcon}>{Comp}</div> }
                <div className={Styles.navText}>{primary}</div>
            </div>
            <div className={Styles.navButtons}>
                { full.ExternalLink && <DobButton size="small" color="silent" onClick={openExternal} icon="box-arrow-up-right" /> }
                <DobButton size="small" color="silent" onClick={(e) => onRemove?.(e, full)} icon="star-fill" />
            </div>
        </Link>
    );
}

export default MenuFavoriteItemLink;
